
import { CSSProperties } from 'react';

export const recentChatStyles: { [key: string]: CSSProperties } = {
  recentChats: {
    width: '350px',
    height: '70vh',
    padding: '16px',
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    border: '1px solid #808080',
    backgroundColor: '#fafafa',
    boxShadow: '0px 4px 8px -2px rgba(0, 0, 0, 0.4)',
  },
  recentChatsHeading: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  recentChatsHeadingTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '18px',
    fontWeight: 400,
    color: '#262626',
  },
  recentChatsHeadingClear: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '12px',
    fontWeight: 400,
    cursor: 'pointer',
  },
  recentChatsList: {
    flexGrow: 1,
    overflowY: 'auto',
    gap: '16px',
  },
  recentChatsListHeading: {
    fontSize: '16px',
    fontWeight: 400,
    color: '#262626',
  },
  recentChatsListItems: {
    fontSize: '12px',
    fontWeight: 400,
    listStyle: 'none',
    padding: 0,
    margin: 0,
    color: '#404040',
  },
  recentChatsListItem: {
    marginBottom: '5px',
  },
  recentChatsFooter: {
    fontSize: '11px',
    fontWeight: 400,
    color: '#262626'
  },
  noChatsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '8px'
  },
  noChatsMessage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    fontSize: '18px',
    fontWeight: 'bold'
  },
  newChat: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '16px',
    cursor: 'pointer'
  }
};

export type RecentChatsStyles = typeof recentChatStyles;